import Cookies from 'js-cookie';

const AUTH_TOKEN_KEY = 'sp_auth_token';
const AUTH_USER_KEY = 'sp_auth_user';

// Secure cookie options
const cookieOpts = {
  expires: 7, // days
  sameSite: 'strict',
  // `secure: true` should be enabled in production (HTTPS)
  secure: typeof window !== 'undefined' && window.location.protocol === 'https:',
};

export const authCookies = {
  setToken(token) {
    Cookies.set(AUTH_TOKEN_KEY, token, cookieOpts);
  },
  getToken() {
    return Cookies.get(AUTH_TOKEN_KEY) || null;
  },
  removeToken() {
    Cookies.remove(AUTH_TOKEN_KEY);
  },
  setUser(user) {
    try {
      Cookies.set(AUTH_USER_KEY, JSON.stringify(user), cookieOpts);
    } catch {
      /* ignore */
    }
  },
  getUser() {
    const raw = Cookies.get(AUTH_USER_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  },
  removeUser() {
    Cookies.remove(AUTH_USER_KEY);
  },
  clear() {
    Cookies.remove(AUTH_TOKEN_KEY);
    Cookies.remove(AUTH_USER_KEY);
  },
};
